import React, { createContext, useContext, useState } from 'react';
import Modal from '../components/Modal';

const NotificationContext = createContext();

export const useNotification = () => useContext(NotificationContext);

export const NotificationProvider = ({ children }) => {
    const [modal, setModal] = useState({
        isOpen: false,
        title: '',
        message: '',
        type: 'info',
        onClose: null
    });

    const showModal = (title, message, type = 'info', onClose = null) => {
        setModal({
            isOpen: true,
            title,
            message,
            type,
            onClose
        });
    };

    const hideModal = () => {
        if (modal.onClose) {
            modal.onClose();
        }
        setModal(prev => ({ ...prev, isOpen: false }));
    };

    return (
        <NotificationContext.Provider value={{ showModal, hideModal }}>
            {children}
            <Modal
                isOpen={modal.isOpen}
                onClose={hideModal}
                title={modal.title}
                message={modal.message}
                type={modal.type}
            />
        </NotificationContext.Provider>
    );
};
